import { eksmoBP } from 'Lib/bp/bp';
import { speed } from 'Lib/speed/speed';
import { getW } from 'Lib/w/w';
import { isTouch } from 'Lib/istouch/istouch';

const $b = $('.article_book');
const $big = $('.article_big-lg');
const $body = $('body');
const sHoverBlock = '.article__hover';
const cHoverBlockActive = 'article__hover_active';
const cHoverBlockShowed = 'article__hover_showed';
const cHorizontal = 'article_horizontal';
const sImg = '.article__img:not(.article__img_d):not(.article__img_m), .article__img.article__img_d';

function showHoverBlock($t) {
    const $hoverBlock = $t.find(sHoverBlock);

    if ($hoverBlock.length) {
        if (!$t.hasClass(cHorizontal)) {
            const $img = $t.find(sImg).first();

            if ($img.length) {
                const imgHeight = $img.height();

                if (imgHeight) {
                    $hoverBlock.css({ 'height': imgHeight });
                }
            }
        }

        $hoverBlock.addClass(cHoverBlockActive);

        setTimeout(() => {
            $hoverBlock.addClass(cHoverBlockShowed);
        });
    }
}

function hideHoverBlock($t) {
    const $hoverBlock = $t.find(sHoverBlock);

    if ($hoverBlock.length) {
        $hoverBlock.removeClass(cHoverBlockShowed);

        setTimeout(() => {
            $hoverBlock.removeClass(cHoverBlockActive);

            if ($t.hasClass(cHorizontal)) {
                $hoverBlock.removeAttr('style');
            }
        }, speed);
    }
}

function setHorizontal() {
    let delimiter = 0;
    const width = getW();

    if (width <= 906) {
        delimiter = 999;
    } else if (width > 906 && width < 1300) {
        delimiter = 2;
    } else if (width > eksmoBP.mdMax) {
        delimiter = 3;
    }

    if (delimiter) {
        $b.each(function (e) {
            if (e < delimiter) {
                $(this).removeClass(cHorizontal);
            } else {
                $(this).addClass(cHorizontal);
            }
        });
    }
}

function setBig() {
    const cBig = 'article_big';
    const cBigOff = 'article_big-off';

    if (getW() < eksmoBP.lgMin) {
        $big.each(function () {
            const $this = $(this);

            if ($this.hasClass(cBig)) {
                $this.removeClass(cBig);
                $this.addClass(cBigOff);
            }
        });
    } else {
        $big.each(function () {
            const $this = $(this);

            if ($this.hasClass(cBigOff)) {
                $this.removeClass(cBigOff);
                $this.addClass(cBig);
            }
        });
    }
}

if ($b.length) {
    $b.on('mouseenter', function () {
        if (!isTouch()) {
            showHoverBlock($(this));
        }
    });

    $b.on('mouseleave', function () {
        if (!isTouch()) {
            hideHoverBlock($(this));
        }
    });

    setHorizontal();
    $body.on('eksmoResizeWidth', setHorizontal);
}

if ($big.length) {
    setBig();
    $body.on('eksmoResizeWidth', setBig);
}
